import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import ApiService from '../../services/apiService';
import { toast } from 'react-toastify';
import { RxCross1 } from "react-icons/rx";
import { useSelector, useDispatch } from 'react-redux';
import { setRows, addRow, removeRow, removeSingleRow, updateRow, clearRows } from '../../../Redux/actions/rowActions';
import { IoAddSharp } from "react-icons/io5";
import { BarLoader, ClipLoader } from 'react-spinners';

const UpdateItemGrid = ({ onRequisitionData, itemData, selectedCheck, handleVatChange, isDiscountPercentage, currencyPrecision }) => {
    const rows = useSelector(state => state.rows.rows);
    const [itemOptions, setItemOptions] = useState([]);
    const [descriptionOptions, setDescriptionOptions] = useState([]);
    const [apiData, setApiData] = useState([]);
    const [vat, setvat] = useState([]);
    const [LazyLoading, setLazyLoading] = useState(true);
    const dispatch = useDispatch();
    const apiService = new ApiService();
    const netAmount = rows.reduce((sum, row) => sum + (parseFloat(row?.amount) || 0), 0)
    const totalVat = rows.reduce((sum, row) => sum + (parseFloat(row?.vatAmount) || 0), 0)
    const totalDiscountAmount = rows.reduce((sum, row) => sum + (parseFloat(row?.discountAmount) || 0), 0)
    const totalDiscount = rows.reduce((sum, row) => sum + (parseFloat(row?.discount) || 0), 0)
    const calculatedTotal = rows.reduce((sum, row) => sum + (parseFloat(row?.amount - row?.vatAmount) || 0), 0)
    useEffect(() => {
        if (rows[0]?.ItemNo) {
            updatevat();
        }
    }, [selectedCheck]);
    useEffect(() => {
        if (apiData) {
            getItems();
        }
    }, [apiData]);
    const updatevat = async () => {
        try {
            const updatedRows = rows.map(row => ({ ...row }));
            const apiPromises = updatedRows.map(async (row, index) => {
                 
                const selectedVat = vat?.find(tax => tax.description === row?.vatDec);
                let amount = row.qty * row.baseAmount
                const perAmount = (amount / 100) * (selectedVat?.rate || 0)
                let excludedAmount = amount + perAmount
                const calculatedAmount = selectedCheck ? excludedAmount : amount;
                let discountamount = 0
                if (isDiscountPercentage) {
                    const discountAmount = (row.discount / 100) * calculatedAmount;
                    discountamount = discountAmount;
                } else {
                    discountamount = row.discount;
                }
                let finalAmount = 0;
                if (isDiscountPercentage) {
                    const discountAmount = (row?.discount / 100) * calculatedAmount;
                    finalAmount = calculatedAmount - (discountAmount || 0);
                } else {
                    finalAmount = calculatedAmount - (row?.discount || 0);
                }
                updatedRows[index].calculatedAmount = calculatedAmount;
                updatedRows[index].amount = calculatedAmount;
                updatedRows[index].vat = selectedVat?.rate || 0;
                updatedRows[index].vatDec = selectedVat?.description || 0;
                updatedRows[index].vatAmount = perAmount;
                updatedRows[index].discountAmount = discountamount;
                updatedRows[index].calculatedAmount = calculatedAmount;
                updatedRows[index].discount = row.discount || 0;
            });
            await Promise.all(apiPromises);
            setRows(updatedRows);
            onRequisitionData(updatedRows);
            dispatch(setRows(updatedRows));
        } catch (error) {
            console.error('Error updating rows with new stock:', error);
        }
    }
    const getVat = async () => {
        let vatParam = `?toPurchase=true`
        const vat = await apiService.getApiParamater('GET_INV_TAX', vatParam);
        setvat(vat.data.result)
    }
    const getItems = async () => {
        try {
            if (apiData) {
                const formattedRows = itemData?.poDetails.map(detail => {
                    const selecteditem = apiData?.find(item => item?.itemDescription === detail?.itemDescription);
                    let amount = detail.qty * detail.unitPrice
                    const perAmount = (amount / 100) * detail?.vatPerc
                    let excludedAmount = amount + perAmount
                    const calculatedAmount = itemData?.costCenter5 === "excluded" ? excludedAmount : amount;
                     
                    let discountamount = 0
                    if (isDiscountPercentage) {
                        const discountAmount = (detail.discount / 100) * calculatedAmount;
                        discountamount = discountAmount;
                    } else {
                        discountamount = detail.discount;
                    }
                    let finalAmount = 0;
                    if (isDiscountPercentage) {
                        const discountAmount = (detail?.discount / 100) * calculatedAmount;
                        finalAmount = calculatedAmount - (discountAmount || 0);
                    } else {
                        finalAmount = calculatedAmount - (detail?.discount || 0);
                    }
                    return {
                        requisitionNo: itemData.requisitionNo || "",
                        srno: detail?.srno,
                        ItemNo: detail.itemCode,
                        recordId: detail.itemCode,
                        itemDescription: detail.itemDescription,
                        qty: detail.qty,
                        uom: detail.uom,
                        stock: selecteditem.convToInvUOM * detail.qty,
                        baseAmount: detail.unitPrice,
                        baseQty: selecteditem.convToInvUOM,
                        specification: detail.specification,
                        amount: calculatedAmount,
                        vat: detail?.vatPerc || 0,
                        vatDec: detail?.vatDesc || '',
                        vatAmount: perAmount,
                        discountAmount: discountamount,
                        calculatedAmount: calculatedAmount,
                        discount: detail.discount
                    };
                }).filter(row => row !== null);

                if (formattedRows.length > 0) {
                    setRows(formattedRows);
                    onRequisitionData(formattedRows);
                    dispatch(setRows(formattedRows));
                    setLazyLoading(false)
                }
            }
        } catch (error) {
            console.error('Error fetching items:', error);
        }
    };
    useEffect(() => {
        fetchData();
        getVat()
    }, []);
    const fetchData = async () => {
        try {
            const response = await apiService.getApiParamater('GET_ITEM_PACK', '?isActive=true');
            const selecteditem = response.data.result?.filter(rec => rec.exp9 === '1')
            if (response?.data?.result?.length > 0) {
                setApiData(selecteditem);
                setItemOptions(selecteditem.map(item => ({
                    value: item.itemNo,
                    label: item.itemNo
                })));
                setDescriptionOptions(selecteditem.map(item => ({
                    value: item.itemDescription,
                    label: item.itemDescription
                })));
            } else {
                console.error('No data found in the API response');
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const handleInputChange = (index, fieldName, value) => {
        const isDuplicate = rows.some((row, rowIndex) => rowIndex !== index && (row?.ItemNo === value || row.itemDescription === value));
        if (isDuplicate) {
            toast.error('Please choose a different item.');
            return;
        }
        if (fieldName === 'qty' && value < 0) {
            toast.warning('Quantity cannot be less than 0.');
            return;
        }
        const updatedRows = rows?.map((row, rowIndex) => {
            if (rowIndex === index) {
                const updatedRow = { ...row, [fieldName]: value, srno: ("0" + (index + 1)).slice(-2) };
                if (fieldName === 'qty') {
                    const quantity = parseFloat(value);
                    if (quantity < 0) {
                        toast.warning('Quantity cannot be less than 0.');
                        return;
                    }
                }
                if (fieldName === 'ItemNo') {
                    const selectedItem = apiData?.find(item => item.itemNo === value);
                    const selectedVat = vat?.find(tax => tax.description === selectedItem?.vat);
                    if (selectedItem) {
                        updatedRow.itemDescription = selectedItem.itemDescription;
                        updatedRow.ItemNo = selectedItem.itemNo;
                        updatedRow.requisitionNo = selectedItem.itemDescription;
                        updatedRow.uom = selectedItem.baseUnit;
                        updatedRow.specification = selectedItem.specification;
                        updatedRow.vatDec = selectedVat?.description;
                        updatedRow.vat = selectedVat?.rate;
                        updatedRow.stock = 0;
                        updatedRow.baseAmount = selectedItem?.avgPrice || 0;
                        updatedRow.baseQty = parseFloat(selectedItem.convToInvUOM);
                    }
                } else if (fieldName === 'itemDescription') {
                    const selectedItem = apiData?.find(item => item.itemDescription === value);
                    const selectedVat = vat?.find(tax => tax.description === selectedItem?.vat);
                    if (selectedItem) {
                        updatedRow.specification = selectedItem.specification;
                        updatedRow.recordId = selectedItem.itemNo;
                        updatedRow.ItemNo = selectedItem.itemNo;
                        updatedRow.stock = 0;
                        updatedRow.uom = selectedItem.baseUnit;
                        updatedRow.baseQty = parseFloat(selectedItem.convToInvUOM);
                        updatedRow.vatDec = selectedVat?.description;
                        updatedRow.vat = selectedVat?.rate;
                        updatedRow.baseAmount = selectedItem?.avgPrice || 0;
                    }
                }
                if (fieldName === 'qty') {
                    const quantity = parseFloat(value);
                    const selectedItem = apiData?.find(data => data?.itemDescription === row?.itemDescription);
                    const baseQty = selectedItem ? selectedItem.convToInvUOM : 1;
                    updatedRow.stock = selectedItem?.convToInvUOM * quantity || 0;
                    updatedRow.baseQty = parseFloat(baseQty);
                }
                if (fieldName === 'discount') {
                    const discount = parseFloat(value);
                    const selectedItem = apiData?.find(data => data?.itemDescription === row?.itemDescription);
                    const quantity = parseFloat(updatedRow.qty);
                    const unitPrice = parseFloat(updatedRow.baseAmount || 0);
                    const selectedVat = vat?.find(tax => tax?.description === selectedItem?.vat);

                    const amount = quantity * unitPrice;
                    if (discount > amount) {
                        toast.error("Discount must be les then total Amount")
                        return
                    }
                    const vatAmount = (amount / 100) * (selectedVat?.rate || 0);
                    const excludedAmount = amount + vatAmount;
                    const calculatedAmount = selectedCheck ? excludedAmount : amount;
                    let discountamount = 0
                    if (isDiscountPercentage) {
                        const discountAmount = (discount / 100) * calculatedAmount;
                        discountamount = discountAmount;
                    } else {
                        discountamount = discount;
                    }
                    let finalAmount = 0;
                    if (!isNaN(discount) && discount >= 0) {
                        if (isDiscountPercentage) {
                            const discountAmount = (discount / 100) * calculatedAmount;
                            finalAmount = calculatedAmount - discountAmount;
                        } else {
                            finalAmount = calculatedAmount - discount;
                        }
                    } else {
                        finalAmount = calculatedAmount;
                    }

                    updatedRow.amount = finalAmount;
                    updatedRow.calculatedAmount = calculatedAmount;
                    updatedRow.stock = selectedItem?.convToInvUOM * quantity || 0;
                    updatedRow.baseAmount = selectedItem?.avgPrice || 0;
                    updatedRow.discountAmount = discountamount;
                    updatedRow.discount = !isNaN(discount) && discount >= 0 ? discount : 0;
                }
                if (fieldName === 'qty' || fieldName === 'baseAmount') {
                    const selectedItem = apiData?.find(data => data?.itemDescription === row?.itemDescription);
                    const vatl = updatedRow.vatDec;
                     
                    const selectedVat = vat?.find(tax => tax?.description === vatl);
                    const quantity = parseFloat(updatedRow.qty);
                    const discount = updatedRow.discount;
                    const unitPrice = parseFloat(updatedRow.baseAmount || 0);
                    let amount = quantity * unitPrice
                    const perAmount = (amount / 100) * selectedVat?.rate
                    let excludedAmount = amount + perAmount
                    const calculatedAmount = selectedCheck ? excludedAmount : amount;
                    let discountamount = 0
                    if (isDiscountPercentage) {
                        const discountAmount = (discount / 100) * calculatedAmount;
                        discountamount = discountAmount;
                    } else {
                        discountamount = discount;
                    }
                    let finalAmount = 0;
                    if (!isNaN(discount) && discount >= 0) {
                        if (isDiscountPercentage) {
                            const discountAmount = (discount / 100) * calculatedAmount;
                            finalAmount = calculatedAmount - discountAmount;
                        } else {
                            finalAmount = calculatedAmount - discount;
                        }
                    } else {
                        finalAmount = calculatedAmount;
                    }
                    updatedRow.amount = finalAmount;
                    updatedRow.discount = discount;
                    updatedRow.stock = selectedItem?.convToInvUOM * quantity || 0;
                    updatedRow.discountAmount = discountamount;
                    updatedRow.calculatedAmount = calculatedAmount;
                    updatedRow.vatAmount = perAmount;
                }
                if (fieldName === 'vat') {
                    let amount = row.qty * row.baseAmount

                    const perAmount = (amount / 100) * (value?.rate || 0)
                    let excludedAmount = amount + perAmount
                    const calculatedAmount = selectedCheck ? excludedAmount : amount;
                    let discountamount = 0
                    if (isDiscountPercentage) {
                        const discountAmount = (row.discount / 100) * calculatedAmount;
                        discountamount = discountAmount;
                    } else {
                        discountamount = row.discount;
                    }
                    let finalAmount = 0;
                    if (isDiscountPercentage) {
                        const discountAmount = (row?.discount / 100) * calculatedAmount;
                        finalAmount = calculatedAmount - (discountAmount || 0);
                    } else {
                        finalAmount = calculatedAmount - (row?.discount || 0);
                    }
                    updatedRow.calculatedAmount = parseFloat(calculatedAmount);
                    updatedRow.amount = parseFloat(calculatedAmount);
                    updatedRow.vatDec = value?.description;
                    updatedRow.vat = value?.rate;
                    updatedRow.vatAmount = parseFloat(perAmount);
                }
                return updatedRow;
            }
            return row;
        });
        setRows(updatedRows);
        dispatch(setRows(updatedRows));
        onRequisitionData(updatedRows);
    };
    const addNewRow = () => {
        const newRow = {
            srno: '',
            ItemNo: '',
            requisitionNo: '',
            itemDescription: '',
            branch: '',
            qty: '',
            uom: '',
            baseQty: '',
            baseAmount: '',
            amount: '',
            stock: '',
            bol: ''
        };
        dispatch(addRow(newRow));
        const updatedRows = [...rows, newRow];
        onRequisitionData(updatedRows);
        dispatch(setRows(updatedRows));
    };
    const handleRemoveRow = (index) => {
        dispatch(removeSingleRow(index));
        const updatedRows = rows
            .filter((_, i) => i !== index)
            .map((row, i) => ({
                ...row,
                srno: i + 1
            }));
        onRequisitionData(updatedRows);
        dispatch(setRows(updatedRows));
        setRows(updatedRows);
    };
    const preventNegativeSign = (e) => {
        if (e.key === "-" || e.key === "+") {
            e.preventDefault();
        }
    };
    return (
        <div>
            <div className='table-container p-2 mb-5' style={{ overflowX: 'auto', height: "400px" }}>
                {LazyLoading === true ?
                    <div className='center p-5'>
                        <BarLoader color="#6E5199" size={50} height={3} width={300} />
                    </div>
                    :
                    <>
                        <table>
                            <thead className='dynoTable' >
                                <tr>
                                    <th></th>
                                    <th>Sr no</th>
                                    <th>Item No</th>
                                    <th>Description</th>
                                    <th>Item Specs</th>
                                    <th>Qty</th>
                                    <th>Packing UOM</th>
                                    <th>Inventory Qty</th>
                                    <th>Unit Price</th>
                                    <th>Discount</th>
                                    <th>VAT %</th>
                                    <th>VAT Amount</th>
                                    <th>Amount</th>
                                </tr>
                            </thead>
                            <tbody>
                                <>{Array.isArray(rows) && rows?.map((row, index) => (
                                    <tr key={index}>
                                        {itemData?.requisitionNo === '' ?
                                            <td className='m-0 p-0' style={{ border: "1px solid rgba(118, 118, 118, 0.3)" }}>
                                                <div className='center' onClick={() => handleRemoveRow(index)} > <RxCross1 size={15} /></div></td> :
                                            <td className='m-0 p-0' style={{ border: "1px solid rgba(118, 118, 118, 0.3)" }}>
                                                <div className='center'> <RxCross1 size={15} /></div></td>
                                        }
                                        <td className='m-0 p-0'><input className='p-2' type="text" value={row?.srno} disabled style={{ width: "120px" }} /></td>
                                        <td className='m-0 p-0'>
                                            {itemData?.requisitionNo === '' ?
                                                <Select className="flex-grow-1"
                                                    theme={(theme) => ({
                                                        ...theme,
                                                        padding: 10
                                                    })}
                                                    options={itemOptions}
                                                    value={{ value: row.ItemNo, label: row.ItemNo }}
                                                    onChange={selectedOption => handleInputChange(index, 'ItemNo', selectedOption.value)} />
                                                :
                                                <td className='m-0 p-0'><input className='p-2' disabled value={row.ItemNo} style={{ width: "120px" }} /></td>
                                            }
                                        </td>
                                        <td className='m-0 p-0'>
                                            {itemData?.requisitionNo === '' ?
                                                <Select
                                                    className="flex-grow-1"
                                                    theme={(theme) => ({
                                                        ...theme,
                                                        padding: 10
                                                    })}
                                                    options={descriptionOptions}
                                                    value={{ value: row.itemDescription, label: row.itemDescription }}
                                                    onChange={selectedOption => handleInputChange(index, 'itemDescription', selectedOption.value)}
                                                />
                                                :
                                                <td className='m-0 p-0'><input className='p-2' disabled value={row.itemDescription} style={{ width: "140px" }} /></td>
                                            }
                                        </td>
                                        <td className='m-0 p-0'><input className='p-2' type="text" disabled={itemData?.requisitionNo === '' ? false : true}
                                            value={row.specification} onChange={e => handleInputChange(index, 'specification', e.target.value)}
                                            style={{ width: "120px" }} />
                                        </td>
                                        <td className='m-0 p-0'><input className='p-2' disabled={itemData?.requisitionNo === '' ? false : true}
                                            onWheel={(e) => e.target.blur()} style={{ width: "120px" }}
                                            type="number" value={row.qty} onChange={e => handleInputChange(index, 'qty', e.target.value)}
                                            onKeyDown={preventNegativeSign}
                                        /></td>
                                        <td className='m-0 p-0'><input className='p-2' disabled={true} type="text" value={row.uom} style={{ width: "140px" }} /></td>
                                        <td className='m-0 p-0'><input className='p-2' disabled type="text" value={row.stock || 0} style={{ width: "140px" }} /></td>
                                        <td className='m-0 p-0'><input className='p-2' disabled={itemData?.requisitionNo === '' ? false : true}
                                            onWheel={(e) => e.target.blur()} style={{ width: "120px" }}
                                            type="number" value={row.baseAmount} onChange={e => handleInputChange(index, 'baseAmount', e.target.value)}
                                            onKeyDown={preventNegativeSign}
                                        /></td>
                                        <td className='m-0 p-0'><input className='p-2' disabled type="number" value={row.discount} style={{ width: "120px" }} /></td>
                                        <td className='m-0 p-0'>
                                            <Select className="flex-grow-1"
                                                theme={(theme) => ({
                                                    ...theme,
                                                    padding: 10
                                                })}
                                                value={{ value: row.vatDec, label: row.vatDec }}
                                                options={vat?.map((vat) => ({ value: vat, label: vat?.description }))}
                                                onChange={selectedOption => handleInputChange(index, 'vat', selectedOption.value)} />
                                        </td>
                                        <td className='m-0 p-0'><input className='p-2' type="text"
                                            value={Number(row?.vatAmount || 0).toFixed(currencyPrecision || 0)} disabled style={{ width: "120px" }} /></td>
                                        <td className='m-0 p-0'><input className='p-2' disabled style={{ width: "120px" }}
                                            type="text" value={(row.amount === NaN ? 0 : Number(row.amount || 0).toFixed(currencyPrecision || 0) || 0)} /></td>
                                    </tr>
                                ))}</>
                            </tbody>
                        </table>
                        {itemData?.requisitionNo === '' ?
                            <div className='d-flex gap-5'>
                                <button className='mainbtn  mt-4 gap-3' onClick={addNewRow}><div>Add</div> <IoAddSharp color='#fff' className='center mt-1 mx-2' /> </button>
                            </div> : ""}
                    </>
                }
            </div>
            <div className='d-flex justify-content-between boxs'>
                <div className='d-flex gap-2'>
                    <div className="totalhead center">Discount</div>
                    <div className='field'>{`${totalDiscount.toFixed(currencyPrecision || 0)} ${(isDiscountPercentage === true ? "%" : " ")}` || "---"}</div>
                </div>
                <div className='d-flex gap-2'>
                    <div className="totalhead center">Total Amount</div>
                    <div className='field'>{calculatedTotal.toFixed(currencyPrecision || 0) || "---"}</div>
                </div>
                <div className='d-flex gap-2'>
                    <div className="totalhead center">Total Discount</div>
                    <div className='field'>{totalDiscountAmount.toFixed(currencyPrecision || 0) || "---"}</div>
                </div>
                <div className='d-flex gap-2'>
                    <div className="totalhead center">Total Vat</div>
                    <div className='field'>{totalVat.toFixed(currencyPrecision || 0) || "---"}</div>
                </div>
                <div className='d-flex gap-2'>
                    <div className="totalhead center">Net Amount</div>
                    <div className='field'>{netAmount.toFixed(currencyPrecision || 0) || "---"}</div>
                </div>
            </div>
        </div>
    );
};

export default UpdateItemGrid;
